<template>
  <el-popover placement="bottom" :width="inputWidth" trigger="click" @show="show">
    <el-input :value="input" slot="reference" ref="input" :size="size" clearable :style="{ width: `${inputWidth}px` }" :placeholder="placeholder" @focus="focus" @clear="clear">
      <el-select v-model="select" slot="prepend" :style="{ width: `${selectWidth}px` }" :placeholder="selectPlaceholder" @change="selectChange">
        <el-option v-for="item in option" :key="item.value" :label="item.label" :value="item.value" />
      </el-select>
      <el-button slot="append" icon="el-icon-search" @click="search" />
    </el-input>

    <template>
      <el-input v-model="textarea" ref="textarea" type="textarea" resize="none" :rows="6" :placeholder="placeholder" />
    </template>
  </el-popover>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      required: false,
      default: 'medium'
    },
    round: {
      type: Boolean,
      required: false,
      default: false
    },
    inputWidth: {
      type: Number,
      required: false,
      default: 380
    },
    placeholder: {
      type: String,
      required: false,
      default: 'Searching for order id'
    },
    selected: {
      type: [Number, String],
      required: false
    },
    selectWidth: {
      type: Number,
      required: false,
      default: 120
    },
    selectPlaceholder: {
      type: String,
      required: false,
      default: 'Select'
    },
    option: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data() {
    return {
      input: undefined,
      select: this.selected,
      textarea: undefined
    }
  },
  watch: {
    textarea(value) {
      if (value) {
        let result = value.split(/[\r\n]+/).filter((item) => item !== '')
        this.input = result.join(',')
      }
    }
  },
  methods: {
    focus() {
      this.$refs.input.blur()
    },

    clear() {
      this.input = undefined
      this.textarea = undefined
      this.$emit('clear')
    },

    show() {
      this.$nextTick(() => {
        this.$refs.textarea.focus()
      })
    },

    selectChange(value) {
      this.$emit('select', value)
    },

    search() {
      this.$emit('search', this.input)
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.el-popover {
  border-radius: 12px;
}

/deep/.el-input-group__prepend {
  background-color: #fff;
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
}

/deep/.el-input-group__append {
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
}

/deep/.el-input__inner {
  border-radius: 0 !important;
}
</style>
